


















import Vue from 'vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { USER_NS } from '~/store/modules/shared/user/state'
import Breadcrumbs from '~/components/car/Breadcrumbs.vue'
import Header from '~/components/car/classifieds/form/header/Header.vue'
import Fieldsets from '~/components/car/classifieds/form/fieldsets/Fieldsets.vue'
import NewClassifiedRegisterPrompt from '~/components/car/classifieds/form/header/info/NewClassifiedRegisterPrompt.vue'
import {
  RESET_TO_INITIAL_FIELD_VALUES_DATA,
  SET_CATEGORY_ID,
  SET_CONFIG,
  SET_EDIT_MODE,
  SET_PAGE_KEY,
  SET_ROOT_CATEGORY_ID
} from '~/store/modules/shared/classifieds/form/mutation-types'
import { CategoryId } from '~/models/category/types'
import { MetaItem } from '~/models/head/types'
import { getRouteMetaItem } from '~/utils/router'
import TopAlert from '~/components/car/classifieds/form/TopAlert.vue'
import HeadService from '~/services/HeadService'
import { getFormConfig } from '~/utils/form'
import CAnonGuardNewClassifiedModal from '~/components/shared/configurable/user/CAnonGuardNewClassifiedModal.vue'
import { ANON_GUARD_COOKIE } from '~/constants/anon-guard'

export default Vue.extend({
  components: {
    CAnonGuardNewClassifiedModal,
    Breadcrumbs,
    Header,
    Fieldsets,
    NewClassifiedRegisterPrompt,
    TopAlert
  },
  async fetch() {
    const errorFn = (statusCode: number, message: string = '') => {
      if (process.server) {
        this.$nuxt.context.res.statusCode = statusCode
        this.$fetchState.error = new Error(message)
      } else {
        this.$nuxt.error({ statusCode, message })
      }
    }

    const rootCategoryId =
      getRouteMetaItem(this.$route, 'rootCategoryId') || CategoryId.CLASSIFIEDS

    this.$store.commit(
      `${CLASSIFIED_FORM_NS}/${SET_CONFIG}`,
      getFormConfig(rootCategoryId)
    )
    this.$store.commit(
      `${CLASSIFIED_FORM_NS}/${SET_CATEGORY_ID}`,
      Number(this.$route.params.categoryId)
    )
    this.$store.commit(`${CLASSIFIED_FORM_NS}/${SET_EDIT_MODE}`, false)
    this.$store.commit(
      `${CLASSIFIED_FORM_NS}/${SET_ROOT_CATEGORY_ID}`,
      rootCategoryId
    )
    const { copy: classifiedIdToCopy } = this.$route.query
    if (classifiedIdToCopy) {
      return Promise.all([
        this.$store.dispatch(
          `${CLASSIFIED_FORM_NS}/loadCopyFieldValues`,
          classifiedIdToCopy
        ),
        this.$store.dispatch(`${CLASSIFIED_FORM_NS}/loadSchema`)
      ])
    }

    try {
      await this.$store.dispatch(
        `${CLASSIFIED_FORM_NS}/loadSchemaAndFieldValues`
      )
      // the following line will force form components to re-render (for example going from edit to new)
      this.$store.commit(`${CLASSIFIED_FORM_NS}/${SET_PAGE_KEY}`, 'new')
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        const { status: statusCode, error: message } = data
        return errorFn(statusCode, message)
      } else {
        this.$logger.captureError(error)
        return errorFn(500)
      }
    }
  },
  data() {
    return {
      anonGuardModalVisible: false
    }
  },
  middleware: ['needs-guest-complete-profile'],
  computed: {
    ...mapState(CLASSIFIED_FORM_NS, {
      breadcrumbs: state => state.page.breadcrumbs
    }),
    ...mapGetters(USER_NS, {
      userIsAnon: 'isAnon',
      userIsSingle: 'isSingle'
    }),
    ...mapGetters(CLASSIFIED_FORM_NS, {
      formChanged: 'formChanged'
    })
  },
  mounted() {
    if (this.userIsAnon && !this.$cookies.get(ANON_GUARD_COOKIE)) {
      this.anonGuardModalVisible = true
    }
  },
  methods: {
    ...mapMutations(CLASSIFIED_FORM_NS, {
      resetToInitialFieldValues: RESET_TO_INITIAL_FIELD_VALUES_DATA
    })
  },
  beforeRouteLeave(_to, _from, next) {
    if (this.formChanged) {
      const answer = window.confirm(
        `${this.$t('there are unsaved changes in this page')}. ${this.$t(
          'do you really want to leave?'
        )}`
      )
      if (!answer) return false
      this.resetToInitialFieldValues()
    }
    next()
  },
  head() {
    const { page } = this.$store.state.classifieds.form
    const {
      title,
      metadata: meta
    }: { title: string; metadata: MetaItem[] } = page
    const headService = this.$dep(HeadService)
    return headService.createHead({ title, meta })
  }
})
